import { getTheme, mergeStyleSets } from '@fluentui/react';

interface ISettingAreaPageClassNames {
    settingAreaPageContainer: string;
}

export const useClassNames = (): ISettingAreaPageClassNames => {
    const applicationTheme = getTheme();

    return mergeStyleSets({
        settingAreaPageContainer: {
            background: applicationTheme.semanticColors.bodyBackground
        }
    });
}